/**
 * Created by tomnotcat on 2021/11/15.
 */
import AppConfig from "../config/AppConfig";
//import ApiService from "../services/ApiService";
import EventEmitter from "./EventEmitter";
import _ from "lodash";
import UploadService from "../services/screens/common/UploadService";
import UnitService from "../services/screens/common/UnitService";
import localStorageFileHelper from "../../utils/LocalStorageFileHelper";

class UploadTask {
    constructor(key, file, form) {
        this.taskType = 0;
        this.key = key;
        this.file = file;
        this.form = form;
        this.retry = 0;
    }
}

class UnitUploadTask {
    constructor(key, file, ownerId, ownerType, unitId) {
        this.taskType = 1;
        this.key = key;
        this.file = file;
        this.ownerId = ownerId;
        this.ownerType = ownerType;
        this.unitId = unitId;
    }
}

class UnitImmediateUploadTask {
    constructor(key, file, ownerId, ownerType, unitId) {
        this.taskType = 2;
        this.key = key;
        this.file = file;
        this.ownerId = ownerId;
        this.ownerType = ownerType;
        this.unitId = unitId;
    }
}

class UploadManager {
    constructor(concurrent, maxretry) {
        this._concurrent = _.isNumber(concurrent) ? concurrent : 3;
        this._maxretry = _.isNumber(maxretry) ? maxretry : 3;
        this._events = new EventEmitter();
        this._waitings = [];
        this._uploading = new Map();
    }

    _startTask(task) {
        // const fileName = task.file;
        // const fileUri = `file://${fileName}`;
        const file = task.file;

        const commonSuccessCallback = response => {
            if (this._uploading.get(task.key) === task) {
                this._uploading.delete(task.key);
                this._events.emit("success", { key: task.key, file: task.file }, response);
                this._uploadNext();
            }
        };

        const commonFailureCallback = error => {
            console.warn("upload error:", task.key, error);
            if (this._uploading.get(task.key) === task) {
                this._uploading.delete(task.key);
                if (task.retry < this._maxretry) {
                    // retry next time
                    // TODO: add retry delay time
                    task.retry += 1;
                    this._waitings.push(task);
                } else {
                    // max retried, task failure
                    this._events.emit("failure", { key: task.key, file: task.file }, error);
                }
                this._uploadNext();
            }
        };

        localStorageFileHelper.getFile(file).then(fileZ => {
            switch (task.taskType) {
                case 1:
                    UnitService.uploadFile(task.ownerId, task.ownerType, task.unitId, fileZ, commonSuccessCallback, commonFailureCallback);
                    break;
                case 2:
                    UnitService.uploadFileImmediately(task.ownerId, task.ownerType, task.unitId, fileZ, commonSuccessCallback, commonFailureCallback);
                    break;
                default:
                    UploadService.uploadFile(fileZ, commonSuccessCallback, commonFailureCallback);
                    break;
            }
        });

        /*
        ApiService.post("/common/file/upload", task.form, response => {
            if (this._uploading.get(task.key) === task) {
                this._uploading.delete(task.key);
                this._events.emit('success', {key: task.key, file: task.file}, response);
                this._uploadNext();
            }
        }, (error) => {
            console.warn('upload error:', task.key, error);
            if (this._uploading.get(task.key) === task) {
                this._uploading.delete(task.key);
                if (task.retry < this._maxretry) {
                    // retry next time
                    // TODO: add retry delay time
                    task.retry += 1;
                    this._waitings.push(task);
                }
                else {
                    // max retried, task failure
                    this._events.emit('failure', {key: task.key, file: task.file}, error);
                }
                this._uploadNext();
            }
        });
        */
    }

    _uploadNext() {
        if (this._waitings.length > 0 && this._uploading.size < this._concurrent) {
            var task = this._waitings.shift();
            this._uploading.set(task.key, task);
            this._startTask(task);
        }
    }

    _indexOfWaiting(key) {
        for (var i = 0; i < this._waitings.length; ++i) {
            if (this._waitings[i].key === key) {
                return i;
            }
        }
        return -1;
    }

    get events() {
        return this._events;
    }

    get size() {
        return this._waitings.length + this._uploading.size;
    }

    addTask(task) {
        this._waitings.push(task);
        this._uploadNext();
    }

    addTaskByKey(key, fileName, fields) {
        if (!key) {
            console.warn("invalid upload key:", key);
            return;
        }

        if (!fields) {
            console.warn("invalid upload fields:", fields);
            return;
        }

        if (this._indexOfWaiting(key) >= 0 || this._uploading.has(key)) {
            console.warn("upload key conflict:", key);
            return;
        }

        var form = new FormData();
        for (var k in fields) {
            form.append(k, fields[k]);
        }

        if (!fields["clientType"]) {
            form.append("clientType", 1);
        }
        if (!fields["clientVersion"]) {
            form.append("clientVersion", AppConfig.APP_CLIENT_VERSION);
        }
        if (!fields["clientBuild"]) {
            form.append("clientBuild", AppConfig.APP_CLIENT_BUILD);
        }

        form.append("fileData", fileName);
        this._waitings.push(new UploadTask(key, fileName, form));
        this._uploadNext();
    }

    removeTask(key) {
        // TODO: abort http request?
        this._uploading.delete(key);
        var index = this._indexOfWaiting(key);
        if (index >= 0) {
            this._waitings.splice(index, 1);
        }
    }

    clear() {
        // TODO: abort http request?
        this._waitings = [];
        this._uploading.clear();
    }
}

export default UploadManager;
export { UnitImmediateUploadTask, UnitUploadTask, UploadTask };
